// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueTranslate from 'vue-translate-plugin'

Vue.config.productionTip = false

Vue.use(VueTranslate);

// window.locales = {
//     non_Danish: {
//         'Indtast Ord / Navn' : 'Indtast Ord / Navn',
//         'Hele værdien' : 'Hele verdien',
//         'Konsonant' : 'Konsonant',
//         'Vocal' : 'Vocal'
//     },
//     da_DK: {
//     }
// }
// window.locale  = 'non_Danish';

var translations = {};
if (typeof window.locales !== 'undefined') {
    translations = window.locales;
}

Vue.locales(translations);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js